'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';


export default function projectLandTable() {
    return {
        restrict: 'A',
        template: require('../../../../../view/table.html'),
        transclude: false,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            project: '=myProject',
            edit: '=edit',
            changed: '=?myChanged',
        },
        controller: ['$scope', '$utils', 'LandService', 'AttachmentService',
                     function($scope, $utils, LandService, AttachmentService) {
                         $scope.select = select;
                         $scope.refresh = refresh;
                         $scope.isSelect = isSelect;
                         $scope.dblClick = dblClick;
                         $scope.getItems = getItems;
                         $scope.getValue = $utils.getValue;
                         $scope.showAttachments = AttachmentService.show;

                         init();

                         // region Function

                         function init() {
                             if (!$scope.selectedItem) {
                                 $scope.selectedItem = {};
                             }

                             $scope.columns = [{
                                 name: 'Муниципальное образование',
                                 data: 'land.municipality.name',
                             }, {
                                 name: 'Кадастровый номер',
                                 data: 'land.regNum',
                                 type: 'link',
                                 getHref: (item) => LandService.getExternalURI(item.land),
                             }, {
                                 name: 'Категория земель',
                                 data: 'land.category.name',
                             }, {
                                 name: 'Владелец',
                                 data: 'land.owner',
                             }, {
                                 name: 'Форма владения',
                                 data: 'land.ownershipForm.name',
                             }, {
                                 name: 'Площадь, кв. м.',
                                 data: 'land.area',
                             },
                             {
                                name: 'Адрес',
                                data: 'land.address',
                            }, {
                                 name: 'Вложения',
                                 data: 'land.attachments',
                                 type: 'attachments',
                             }];

                             $scope.searching = {
                                 isSearch: $scope.isSearch,
                                 filter: null,
                             };

                             $scope.pagination = {
                                 isPaging: $scope.isPaging,
                                 page: 1,
                                 size: $scope.isPaging ? 10 : null,
                                 totalPages: null,
                                 totalItems: null,
                             };

                             $scope.toolbox = {
                                 buttons: {
                                     create: {
                                         show: () => $scope.edit,
                                         click: () => {
                                             LandService.select().result.then(function(data) {
                                                 if (!$scope.items.some((item) => equals(item, {land: data}))) {
                                                     $scope.items.push({land: data});
                                                 }
                                             });
                                         },
                                         disabled: () => false,
                                     },
                                     remove: {
                                         show: () => $scope.edit,
                                         click: (item) => {
                                             $scope.items.splice($scope.items.indexOf($scope.items.find((it) => equals(it, item))), 1);
                                             angular.copy({}, $scope.selectedItem);
                                         },
                                         disabled: () => !isSelected(),
                                     },
                                     refresh: {
                                         show: () => false,
                                         click: $scope.refresh,
                                         disabled: () => false,
                                     },
                                 },
                             };

                             refresh();
                         }

                         function refresh() {
                             if (Array.isArray($scope.items)) {
                                 if ($scope.items.every((i) => !equals(i, getSelected()))) {
                                     $scope.selectedItem = {};
                                 }
                                 if (($scope.items.length > 0) && !isSelected()) {
                                     $scope.selectedItem = $scope.items[0];
                                 }
                             }
                         }

                         function dblClick(item) {
                             switch ($scope.type) {
                                 case 'table':
                                     if ($scope.toolbox.buttons.edit) {
                                         $scope.toolbox.buttons.edit.click(item);
                                     }
                                     break;
                                 case 'select':
                                     $scope.ok();
                                     break;
                             }
                         }

                         function select(item) {
                             if (!$scope.isSelect(item)) {
                                 $scope.selectedItem = item;
                             } else {
                                 $scope.selectedItem = {};
                             }
                         }

                         function isSelect(item) {
                             return equals($scope.selectedItem, item);
                         }

                         function isSelected() {
                             return $scope.selectedItem != null && $scope.selectedItem.land != null && $scope.selectedItem.land.id != null;
                         }

                         function getSelected() {
                             return $scope.selectedItem;
                         }

                         function equals(i1, i2) {
                             if (i1 == null || i2 == null || i1.land == null || i2.land == null) {
                                 return false;
                             }
                             return ((i1.land.id == i2.land.id));
                         }

                         function getItems() {
                             return $scope.items;
                         }

                         // endregion

                         // region Watcher

                         $scope.$watch('items', function() {
                             refresh();
                         });

                         // endregion
                     }],
    };
}
